<template>
  <div class="parContaioner">
    <div class="parice">
      <span><span style="font-size: 0.6rem">¥</span>{{ parice }}</span>
    </div>
    <p style="margin: 0.2rem 0.35rem; font-size: 0.32rem; text-align: left">
      支付方式
    </p>
    <md-field class="radio-field">

      <div v-for="(item, index) in banks" :key="index">
        <div
          class="paylinshe"
          v-if="item.code != 'wx'&&index>0"
          @click="paywap(item, index)"
        >
          <div class="listebnr">
            <img :src="item.img" alt="" v-if="index > 0" />
            <img src="@/assets/image/icon_balance.png" alt="" v-else />
            <span>{{ item.name }}</span>
          </div>
          <div class="lischeckj">
            <div class="serbrtn" v-if="item.isService">
              <span>{{ item.serviceFee }}%手续费</span>
            </div>
            <div
              class="serbrtn"
              style="border: none"
              v-if="item.code === 'taobao'"
              @click.stop="gourl"
            >
              <span>前往淘宝店铺</span>
            </div>
            <md-icon
              v-if="index === code"
              name="success"
              color="orangeRed"
              size="lg"
            ></md-icon>
            <md-icon v-if="index != code" name="check" size="lg"></md-icon>
          </div>
        </div>
        <p v-if="item.waring" class="waring">{{ item.waring }}</p>
          <div
            class="paylinshe"
            v-if="index===0"
            @click="paywap(item, index)"
          >
            <div class="listebnr">
              <img :src="item.img" alt="" v-if="index > 0" />
              <img src="@/assets/image/icon_balance.png" alt="" v-else />
              <span>{{ item.name }}</span>
              <p style="margin-left: 0.2rem;color: orangered;font-size: 0.3rem">¥{{account}}</p>
              <p v-if="parseFloat(parice)>parseFloat(account)" style="margin-left: 0.2rem;color: #666666">(余额不足)</p>
            </div>
            <div class="lischeckj">
              <md-icon
                v-if="index === code"
                name="success"
                color="orangeRed"
                size="lg"
              ></md-icon>
              <md-icon v-if="index != code" name="check" size="lg"></md-icon>
            </div>
          </div>

      </div>
    </md-field>

    <md-button type="warning" @click="pay" style="margin-top: 2rem">
      <md-activity-indicator
        v-if="loading"
        class="md-activity-indicator-css"
        type="carousel"
        :size="15"
        color="#fff"
        text-color="#fff"
      ></md-activity-indicator>
      <span v-else>確認支付</span>
    </md-button>
    <div v-html="payGateWay" style="width: 100%; height: 1rem">
      {{ payGateWay }}
    </div>
    <md-dialog
      :closable="false"
      v-model="slotDialog.open"
      :btns="slotDialog.btns"
    >
      <div class="dialog-banner" slot="header">
        <h3>淘宝店铺支付</h3>
        <div class="tipcontainer">
          <span
            >提交成功，请耐心等待工作人员审核您的支付状态，如有疑问请咨询客服</span
          >
        </div>
      </div>
      <md-input-item
        ref="input0"
        title="淘宝订单号:"
        v-model="remark"
        placeholder="请输入淘宝支付的订单号"
      />
    </md-dialog>
  </div>
</template>

<script>
import {
  Amount,
  Field,
  RadioList,
  Button,
  Dialog,
  Toast,
  InputItem,
  ActivityIndicator
} from "mand-mobile";

export default {
  name: "pay",
  components: {
    [Amount.name]: Amount,
    [Field.name]: Field,
    [Button.name]: Button,
    [ActivityIndicator.name]: ActivityIndicator,
    [Dialog.name]: Dialog,
    [RadioList.name]: RadioList,
    [InputItem.name]: InputItem
  },
  data() {
    return {
      parice: 0,
      myBank: "1",
      code: null,
      remark: "",
      loading: false,
      payGateWay: "",
      type: "0",
      account:0,
      isSubmit:false,
      banks: [{ img: "@/assets/image/icon_balance.png", name: "余额支付" }],
      way: {},
      slotDialog: {
        open: false,
        btns: [
          {
            text: "取消",
            handler: this.onBasicCancel
          },
          {
            text: "确认操作",
            handler: this.onBasicConfirm
          }
        ]
      }
    };
  },
  activated() {
    this.loading = false;
    this.parice = this.$route.query.price;
    this.payList();
    this.getUserAccount()
  },
  beforeRouteLeave(to, from, next) {
    // 通过地址查询是否带有跳转标示
    let backHome = this.$route.query.backhome; // 有标示 且 要跳转的路由不等于 A 页面时设定即将跳转的路由；否则继续跳转原导航路由
    if (to.name != "Order") {
      next("/Order");
    } else {
      next();
    }
  },
  methods: {
    getUserAccount(){
      this.ajax.AJAx(this.ports.getUserAccount, "post").then((res) => {
        const { money } = res;
        this.account = (money / 100).toFixed(2);
      });
    },
    back(to, form, next) {
      const backHome = this.$route.query.backhome;
      console.log(to.name);
      // 有标示 且 要跳转的路由不等于 A 页面时设定即将跳转的路由；否则继续跳转原导航路由
      next({ name: "Order" });
    },
    onBasicCancel() {
      this.slotDialog.open = false;
      this.loading = false;
    },
    onBasicConfirm() {
      if (this.remark) {

         var myregs =/^[0-9]*$/;
					if (!myregs.test(this.remark)) {
            Toast.failed("输入有误，淘宝订单号为纯数字的编号");
						return
					}
          if(this.isSubmit){
            return;
          }
          this.isSubmit = true;
        const par = {
          orderId: this.$route.query.id,
          taoBaoCode: this.remark
        };
        this.http
          .APIASK(this.ports.taoBaoPay, "post", par)
          .then(res => {
            Toast.succeed("支付成功");
            this.slotDialog.open = false;
            this.isSubmit = false;
            setTimeout(this.$router.replace({ name: "Order" }), 5000);
          })
          .catch(err => {
            this.isSubmit = false;
            this.slotDialog.open = false;
            this.loading = false;
          });
      } else {
        Toast.failed("请输入淘宝支付的订单号");
      }
    },
    paywap(item, index) {
      this.code = index;
      this.way = item;
    },
    pay() {
      const { code } = this;
      if (code === null) {
        Toast.failed("請选择支付方式");
        return;
      }
      this.loading = true;

      // 余额支付
      if (parseInt(code) < 1) {
        this.yuepay();
        return;
      }
      if (this.way.code === "taobao") {
        this.slotDialog.open = true;
        return;
      }
      const par = {
        orderId: this.$route.query.id,
        wayId: this.way.id
      };
      this.http
        .APIASK(this.ports.paysubmit, "post", par)
        .then(res => {
          if (this.way.code === "paypal") {
            var url =
              res.clientUrl +
              "?client_id=" +
              res.paySign +
              "&custom_id=" +
              res.detail.outTradeNo +
              "&amount=" +
              res.detail.totalPrice +
              "&type=1";
            window.location.href = url;
          } else {
            this.payGateWay = res.paySign;
            var that = this;
            setTimeout(function() {
              that.loading = false;
              document.forms[0].submit();
            }, 10);
          }
        })
        .catch(err => {
          this.loading = false;
        });
    },
    yuepay() {
      const par = {
        orderId: this.$route.query.id
      };
      this.http
        .APIASK(this.ports.localPay, "get", par)
        .then(res => {
          Toast.succeed("支付成功");
          setTimeout(this.$router.replace({ name: "Order" }), 3000);
        })
        .catch(err => {
          this.loading = false;
        });
    },
    gourl() {
      this.http.APIASK(this.ports.getUserInfo, "get").then(res => {
        let url = res.pcShopCodeUrl;
        window.location.href = url;
      });
    },
    payList() {
      this.banks = [{ img: "@/assets/image/icon_balance.png", name: "余额支付" }];
      this.http
        .APIASK(this.ports.payway, "post", { outTradeNo: this.$route.query.id })
        .then(res => {
          this.banks = this.banks.concat(res);
        });
    }
  }
};
</script>

<style lang="less">
.parContaioner {
  .parice {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 3rem;
    background-color: white;
    color: #e51c23;
  }

  .md-field {
    padding: 0 0.4rem;
  }

  .md-cell-item-title {
    text-align: left;
  }

  .md-cell-item-brief {
    text-align: right;
  }
  .paylinshe {
    width: 100%;
    height: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgba(248, 248, 248, 100);
    position: relative;
  }
  .waring {
    font-size: 0.22rem;
  }
  .listebnr {
    display: flex;
    height: 100%;
    align-items: center;
    font-size: 0.28rem;
    img {
      width: 0.5rem;
      height: auto;
      margin-right: 0.2rem;
    }
  }

  .lischeckj {
    display: flex;
    justify-content: space-between;
    height: 100%;
    align-items: center;
    .serbrtn {
      width: 1.5rem;
      height: 0.3rem;
      color: rgba(246, 57, 13, 100);
      font-size: 0.24rem;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 1rem;
      border: 1px solid rgba(246, 57, 13, 100);
    }
  }
}
.dialog-banner {
  h3 {
    font-size: 0.3rem;
    margin: 0.2rem;
  }
  .tipcontainer {
    width: 92%;
    margin-left: 4%;
    height: 0.8rem;
    display: flex;
    align-items: flex-start;
    span {
      font-size: 0.2rem;
      color: #f6390d;
      line-height: 0.4rem;
      display: inline-block;
    }
  }
}
.md-dialog-body {
  .md-field-item-title {
    width: 1.5rem;
    font-size: 0.3rem;
  }
  .md-input-item-fake,
  .md-input-item-input {
    font-size: 0.3rem;
  }
}
</style>
